import type {} from "@lit/react";
import { ChartSeries as ChartSeriesElement, } from "@vaadin/charts/vaadin-chart-series.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ChartSeriesElement, };
export type ChartSeriesEventMap = Readonly<{}>;
const events = {} as ChartSeriesEventMap;
export type ChartSeriesProps = WebComponentProps<ChartSeriesElement, ChartSeriesEventMap>;
export const ChartSeries = createComponent({
    elementClass: ChartSeriesElement, events, react: React, tagName: "vaadin-chart-series"
});
